import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';

export interface PowerDMSExportResponse {
  jobId: string;
}

export const getPowerDMSExportIssuedManualData = async (
  manualId: string
): Promise<PowerDMSExportResponse> => {
  const url = `${baseApiUrl()}/lexipub/manuals/issued/v1/manuals/${manualId}/powerdms-export`;
  const data = await fetcher({
    method: 'post',
    url,
  });
  return data as PowerDMSExportResponse;
};

export const triggerPowerDMSExport = async (
  manualId: string,
  onSuccess?: (response: PowerDMSExportResponse) => void,
  onError?: (error: ServerErrorResponse) => void
): Promise<PowerDMSExportResponse> => {
  try {
    const response = await getPowerDMSExportIssuedManualData(manualId);
    if (onSuccess) {
      await onSuccess(response);
    }
    return response;
  } catch (error) {
    if (onError) {
      onError(error as ServerErrorResponse);
    }
    throw error;
  }
};
